// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBody_root__nZ4AR","fullDivider":"ArticleBody_fullDivider__YzvUz","partialDivider":"ArticleBody_partialDivider__mhy5a"};